export default {
  timeUnitMap: {
    DAY: 4,
    HOUR: 3,
    MIN: 2,
    SEC: 1,
  },
}
